import { render, staticRenderFns } from "./Energy.vue?vue&type=template&id=28db3510&scoped=true"
import script from "./Energy.vue?vue&type=script&lang=ts"
export * from "./Energy.vue?vue&type=script&lang=ts"
import style0 from "./Energy.vue?vue&type=style&index=0&id=28db3510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db3510",
  null
  
)

export default component.exports